export default __webpack_public_path__ + "static/media/searchinstitution_mobile.d9d78114.svg";